import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

const Textarea = ({
	className,
	...props
}: React.ComponentProps<'textarea'>) => {
	return (
		<textarea
			className={cn(
				'cathedral-body border-cathedral-border bg-cathedral-surface ring-offset-background placeholder:text-cathedral-brown/70 focus-visible:ring-cathedral-bright aria-[invalid]:border-input-invalid flex min-h-[92px] w-full rounded-sm border px-4 py-2.5 text-base focus-visible:ring-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
				className,
			)}
			{...props}
		/>
	)
}

export { Textarea }
